module.exports = __webpack_public_path__ + "img/logo-white.5433d1de.png";